import axios from '@/config/axios';
import {getField, updateField} from "vuex-map-fields";
import {GET_PROFILE, SET_STATE} from "../mutations";
import StatusesTransformer from '@/modules/StatusesTransformer'
import Helpers from '@/modules/Helpers'


const current = {
    namespaced: true,
    state: {
        documentNumber: '',
        creditStatus: '',
        amount: '',
        term: '',

        RepaidForToday: '',
        DebtForToday: '',
        MonthlyPayment: '',
        balance: '',
        currentOrderPaymentSchedule: 0

    },
    mutations: {
        updateField,
        setCurrentCredit(state, payload){
            state.documentNumber = payload.id;
            state.creditStatus = StatusesTransformer.translateStatus(payload.status);
            state.amount = payload.amount;
            state.term = payload.term;
            state.RepaidForToday = payload.paidAmount;
            state.DebtForToday = payload.paymentToAdvancedRepayment;
            state.MonthlyPayment = payload.amountToPay;
            state.balance = payload.balance;
            state.currentOrderPaymentSchedule = payload.currentOrderPaymentSchedule;
        }
    },
    actions: {
        getCurrentCredit: function () {
            let _this = this;
            axios.get('/json/credit/current').then(
                (response) => {
                    if(response.data.code === 0){
                        if(response.data.data){
                            _this.commit('current/setCurrentCredit', response.data.data);
                        }else{

                        }
                    }


                },
                (response) => {

                }
            )
        }
    },
    getters: {
        getField,
        getCurrentLoan:(state) => {
            return state;
        }
    }
};

export default current;
